import React from 'react';
import PostModel from '../../models/PostModel.js';
import PostFields from '../PostFields.js';

export default ({ postIndex, postModel, widgetModel, data, isFirst, isLast }) => {
	// config contains all the attributes of the base <latest-posts /> element
	// const postModel = props.postModel;
	// const widgetModel = props.widgetModel;
	// const postIndex = props.postIndex;
	// const data = props.data;

	if (!(postModel instanceof PostModel)) {
		return '';
	}

	let title = postModel.getTitle();
	let content = postModel.getContent() || '';
	let date = postModel.getDate();
	let image = postModel.getImage();

	// with form: images right
	//   no form: images left

	let url = postModel.getUrl();
	let isFile = postModel.getIsFileLink();
	let hideAlt = false;
	let postClasses = ['dfe-post'];
	switch(widgetModel.subTemplate) {
		case 'linklist':
		case 'list':
		case 'links':
			widgetModel.subTemplate = 'linklist';
			postClasses.push('dfe-post--list');
			date = null;
			content = null;
			image = null;
			hideAlt = true;
			break;
		case 'detail':
		case 'detailed':
			widgetModel.subTemplate = 'detail';
			postClasses.push('dfe-post--detail')
			date = null;
			image = null;
			break;
		case 'featured':
		case 'feature':
			widgetModel.subTemplate = 'featured';
			postClasses.push('dfe-post--featured')
			break;
	}

	if (isFirst) {
		postClasses.push('dfe-post--isfirst');
	}
	if (isLast) {
		postClasses.push('dfe-post--islast');
	}

	// settings
	let imageHideMobile = Boolean(image && widgetModel.options.contentFields.image.hideMobile);

	if (imageHideMobile) {
		postClasses.push('dfe-post--noimagemobile')
	}

	// special case 1: 'featured' subTemplate / theme - the whole card is linked
	if ('featured' === widgetModel.subTemplate) {
		return (
			<div className={`${postClasses.join(' ')} post-${postModel.id} post-item post-item-${postIndex}`}>
				<div className="dfe-post-body">
					<PostFields.link href={url} noIcon widgetModel={widgetModel} className="dfe-post-link">
						<div className="row dfe-post-row">
							{(image) ? (
								<div className="dfe-post-image image-col col-md-5">
									<div className="dfe-post-image__container dfe-post-image__container--16-9">
										<PostFields.image src={image} alt={title} hideMobile={imageHideMobile} />
									</div>
								</div>
							) : ''}
							<div className="col dfe-post-col">
								{title ? (
									<div className="dfe-post-title post-title">
										<PostFields.title href={url} text={title} widgetModel={widgetModel}></PostFields.title>
									</div>
								) : (
									''
								)}
								{content ? (
									<span className="dfe-post-content post-content" dangerouslySetInnerHTML={{ __html: content }}></span>
								) : (
									''
								)}
								{ isFile ? (
								<div className='dfe-post-download-container'>
									<PostFields.downloadButton url={url} widgetModel={widgetModel} showExtension={true}/>
								</div>
								) : (
								''
								)}
								{date ? <time className='dfe-post-time'>{date}</time> : ''}
								<PostFields.addtlFields postModel={postModel} data={data} widgetModel={widgetModel}></PostFields.addtlFields>
							</div>
						</div>
					</PostFields.link>
				</div>
			</div>
		);
	}

	// special case 2: 'link' subTemplate / theme - the whole card is linked
	if ('linklist' === widgetModel.subTemplate) {
		return (
			<div className={`${postClasses.join(' ')} post-${postModel.id} post-item post-item-${postIndex}`}>
				<div className="dfe-post-body">
					<PostFields.link href={url} noIcon widgetModel={widgetModel} className="dfe-post-link">
						<div className="row dfe-post-row">
							<div className="col dfe-post-col">
								{title ? (
									<div className="dfe-post-title post-title">
										<PostFields.title href={url} text={title} widgetModel={widgetModel}></PostFields.title>
									</div>
								) : (
									''
								)}
							</div>
							{ isFile ? (
							<div className='col dfe-post-col dfe-post-col__file'>
								<div className='dfe-post-download-container'>
									<PostFields.downloadButton url={url} widgetModel={widgetModel} showExtension={false}/>
								</div>
							</div>
							) : (
								''
							)}
						</div>
					</PostFields.link>
				</div>
			</div>
		);
	}

	return (
		<div className={`${postClasses.join(' ')} post-${postModel.id} post-item post-item-${postIndex}`}>
			<div className="dfe-post-body">
				<div className="row dfe-post-row">
					{(image) ? (
						<div className="dfe-post-image dfe-image image-col col-md-5">
							<div className="dfe-post-image__container dfe-post-image__container--16-9">
								<PostFields.image src={image} alt={title} link={url} />
							</div>
						</div>
					) : ''}
					<div className="col dfe-post-col">
						{title ? (
							<div className="dfe-post-title post-title">
								{url ? <PostFields.link href={url} text={title} widgetModel={widgetModel}/> : title}
							</div>
						) : (
							''
						)}
						{content ? (
							<span className="dfe-post-content post-content" dangerouslySetInnerHTML={{ __html: content }}></span>
						) : (
							''
						)}
						{(!hideAlt) ? (
							<>
								<PostFields.addtlFields postModel={postModel} data={data}></PostFields.addtlFields>
								<PostFields.editLink postModel={postModel} widgetModel={widgetModel}></PostFields.editLink>
							</>
						) : ''}
						{date ? <time className='dfe-post-time'>{date}</time> : ''}
					</div>
						{ isFile ? (
							<div className="col dfe-post-col dfe-post-col__file">
								<div className='dfe-post-download-container'>
									<PostFields.downloadButton url={url} widgetModel={widgetModel} showExtension={false} />
								</div>
							</div>
						) : (
							''
						)}
				</div>
			</div>
		</div>
	);
};
